import { DriverGroupDto, UpdateDriverGroupDto } from '@cargovibe/shared-types';

interface SaveDriverGroupDraftParams {
  activeGroup: DriverGroupDto | null;
  draftName: string;
  draftMemberIds: Set<string>;
  updateDriverGroup: (
    variables: { groupId: string; data: UpdateDriverGroupDto },
    options: { onSuccess: () => void }
  ) => void;
  stopEditing: () => void;
  onSaved: () => void;
}

export function saveDriverGroupDraft({
  activeGroup,
  draftName,
  draftMemberIds,
  updateDriverGroup,
  stopEditing,
  onSaved,
}: SaveDriverGroupDraftParams): void {
  const trimmedName: string = draftName.trim();
  if (!activeGroup || !trimmedName) return;

  updateDriverGroup(
    { groupId: activeGroup.id, data: { name: trimmedName, memberIds: [...draftMemberIds] } },
    {
      onSuccess: (): void => {
        stopEditing();
        onSaved();
      },
    }
  );
}
